import { z } from "zod";
//#region src/alerts/inAppNotifications.ts
var InAppNotificationType = /* @__PURE__ */ function(InAppNotificationType) {
	InAppNotificationType["UsageAlert"] = "USAGE_ALERT";
	InAppNotificationType["ErrorAlert"] = "ERROR_ALERT";
	return InAppNotificationType;
}(InAppNotificationType || {});
const InAppNotification = z.object({
	id: z.number(),
	userId: z.number(),
	teamId: z.number(),
	alertId: z.number().optional(),
	triggeredAt: z.string().datetime(),
	type: z.nativeEnum(InAppNotificationType),
	body: z.string(),
	read: z.boolean()
});
//#endregion
export { InAppNotification, InAppNotificationType };

//# sourceMappingURL=inAppNotifications.js.map